import { Modal, Form, Input, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { getTheme } from 'helpers/getTheme';
import Assets from 'assets/icons';
import classes from './TempLink.module.scss';

interface PasswordModalProps {
  open: boolean;
  onSubmit: (password: string) => void;
  onCancel: () => void;
  loading?: boolean;
}

const PASSWORD_LENGTH = 6;

export default function PasswordModal({ 
  open, 
  onSubmit, 
  onCancel, 
  loading = false 
}: PasswordModalProps) {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  const handleSubmit = (values: { password: string }) => {
    onSubmit(values.password);
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };

  return (
    <Modal
      loading={loading}
      className={getTheme()}
      centered
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Assets.LockIcon className={classes.lockIcon} />
          {t('templink.passwordModal.title')}
        </div>
      }
      open={open}
      onOk={() => {
        form.submit();
      }}
      onCancel={handleCancel}
      okText={t('templink.passwordModal.okText')}
      cancelText={t('templink.passwordModal.cancelText')}
      mask={{ closable: false }}
      closable={false}
      width={650}
    >
      <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {t('templink.passwordModal.description')}
      </Typography.Text>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
        autoComplete="off"
      >
        <Form.Item
          name="password"
          label={t('templink.passwordModal.passwordLabel')}
          rules={[
            {
              required: true,
              message: t('templink.passwordModal.validatePassword'),
            },
            {
              len: PASSWORD_LENGTH,
              message: t('templink.passwordModal.validatePasswordLength', { len: PASSWORD_LENGTH }),
            },
          ]}
        >
          <Input.OTP
            length={PASSWORD_LENGTH}
            // больше не имеет пропа placeholder
            // placeholder={t('templink.passwordModal.passwordPlaceholder')}
            disabled={loading}
            style={{ width: '100%' }}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
} 
